// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DiscountSubscriptionEditController = function ($scope, $modalInstance, discountSubscriptionId, contract, DiscountSubscription, DiscountSubscriptionEnd, gettextCatalog, gettext, Contract, PUtill) {
    $scope.contract = contract;
    $scope.endDiscountSubscription = new DiscountSubscriptionEnd();
    $scope.endDiscountSubscription.EndDate = null;

    $scope.getDateToTimeAdjusted = function(date) {
        return Contract.getDateToPhaseStartTimeAdjusted($scope.contract, date);
    };    
    
    DiscountSubscription.get({ discountSubscriptionId: discountSubscriptionId }, function (data) {
        $scope.discountSubscription = data;

        let minutesDiff = moment($scope.discountSubscription.StartDate).diff(new Date(), 'minutes');
        $scope.isNowDisabled = minutesDiff > 0;
        if ($scope.isNowDisabled)
            $scope.setEndDate($scope.discountSubscription.StartDate);
        else
            $scope.setEndDateNow();
    });

    $scope.cancel = function () { $modalInstance.close(); };
    $scope.save = function () {
        $scope.discountSubscription.$update({ discountSubscriptionId: discountSubscriptionId }, function () {
            $modalInstance.close();
            $scope.notify("success", gettextCatalog.getString(gettext("Discount subscription updated successfully")));
        });
    };
    $scope.end = function () {
        $scope.endDiscountSubscription.$save({
            contractId: contract.Id,
            discountSubscriptionId: discountSubscriptionId
        }, function () {
                $modalInstance.close();
                $scope.notify("success", gettextCatalog.getString(gettext("End of discount subscription set successfully")));
            });
    };

    $scope.setEndDateNow = function () {
        $scope.endDiscountSubscription.EndDate = new Date();
        $scope.isNowSelected = true;
    };    

    $scope.setEndDate = function (newDate) {
        $scope.isNowSelected = false;
        $scope.endDiscountSubscription.EndDate = newDate;
    };

    $scope.areDatesEqual = PUtill.areDatesEqual;
};
DiscountSubscriptionEditController.$inject = ['$scope', '$uibModalInstance', 'discountSubscriptionId', 'contract', 'DiscountSubscription', 'DiscountSubscriptionEnd', 'gettextCatalog', 'gettext', 'Contract', 'PUtill'];
 
